import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getTitles = () => async (dispatch) =>  {
    dispatch({
        type: 'MISCELLANEOUS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/miscellaneous/getTitles', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MISCELLANEOUS_GET_TITLES_SUCCESS',
                payload: data?.titles
            })
        } else {
            dispatch({
                type: 'MISCELLANEOUS_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MISCELLANEOUS_NOT_LOADING'
        })
    }
}

export const getCandidateAvailableTowns = (user) => async (dispatch) =>  {
    dispatch({
        type: 'MISCELLANEOUS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/getCandidateAvailableTowns/' + user, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MISCELLANEOUS_GET_TOWNS_SUCCESS',
                payload: data?.towns
            })
        } else {
            dispatch({
                type: 'MISCELLANEOUS_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MISCELLANEOUS_NOT_LOADING'
        })
    }
}

export const getCandidateProvinces = () => async (dispatch) =>  {
    dispatch({
        type: 'MISCELLANEOUS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/miscellaneous/getProvinces', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MISCELLANEOUS_GET_PROVINCES_SUCCESS',
                payload: data?.provinces
            })
        } else {
            dispatch({
                type: 'MISCELLANEOUS_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MISCELLANEOUS_NOT_LOADING'
        })
    }
}

export const getCourseSubjects = () => async (dispatch) =>  {
    dispatch({
        type: 'MISCELLANEOUS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/miscellaneous/getCourseSubjects', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {            
            dispatch({
                type: 'MISCELLANEOUS_GET_SUBJECTS_SUCCESS',
                payload: data?.subjects
            })
        } else {
            dispatch({
                type: 'MISCELLANEOUS_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MISCELLANEOUS_NOT_LOADING'
        })
    }
}

export const getAllSubjects = () => async (dispatch) => {
    dispatch({
        type: 'MISCELLANEOUS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/miscellaneous/getAllSubjects', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MISCELLANEOUS_GET_SUBJECTS_SUCCESS',
                payload: data?.subjects
            })
        } else {
            dispatch({
                type: 'MISCELLANEOUS_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MISCELLANEOUS_NOT_LOADING'
        })
    }
}

export const getLevels = () => async (dispatch) =>  {
    dispatch({
        type: 'MISCELLANEOUS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/miscellaneous/getLevels', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MISCELLANEOUS_GET_LEVELS_SUCCESS',
                payload: data?.levels
            })
        } else {
            dispatch({
                type: 'MISCELLANEOUS_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MISCELLANEOUS_NOT_LOADING'
        })
    }
}